export type AuthMode = 'msal' | 'dev-bypass' | 'sso';

export function getAuthMode(): AuthMode {
  return (import.meta.env.VITE_AUTH_MODE as AuthMode | undefined) ?? 'dev-bypass';
}
